import { createMarkdownRenderer } from './markdown_renderer';

export default function AlpineRemarkViewer() {
  Alpine.data('remarkViewer', (content) => ({
    content: content,
    async init() {
      await this.$nextTick();
      this.renderer = createMarkdownRenderer();
      await this.renderContent(this.content);
      this.$watch('content', (value) => this.renderContent(value || ''));
    },
    async renderContent(value) {
      const html = await this.renderer.render(value || '');
      const preview = this.$refs['markdown-preview'];
      if (preview) {
        preview.innerHTML = html;
      }
    },
  }));
}
